import React from 'react';
import { useLocation } from 'react-router-dom';
import BodyClass from '@plone/volto/helpers/BodyClass/BodyClass';
import ScrollToTop from '@redturtle/iovisit-theme/components/ScrollToTop/ScrollToTop';

const GenericAppExtras = (props) => {
  const location = useLocation();

  const FORCE_PUBLIC_UI = ['/sitemap', '/search'];
  const isPublicUI = FORCE_PUBLIC_UI.reduce(
    (acc, route) => acc || new RegExp(route).test(`/${location.pathname}`),
    false,
  );

  return (
    <>
      {isPublicUI && (
        <>
          <BodyClass className="public-ui" />
          <BodyClass className="cms-ui" remove={true} />
        </>
      )}
      <ScrollToTop />
    </>
  );
};
export default GenericAppExtras;
